import { gql } from '@apollo/client/core';

/* eslint-disable import/prefer-default-export */
export const OPENAI_MUTATION = gql`
  mutation ChatGpt($prompt: String!, $maxTokens: Int!) {
    chatGpt(prompt: $prompt, maxTokens: $maxTokens) {
      response
    }
  }
`;
